@for (video of videoLinks; track video) {
  <app-smart-fix-video-player [videoUrl]="video" class="video-preview"></app-smart-fix-video-player>
}
